<template>
  <div class="dejhglInfo-wrap">
    <div class="dejhglInfo-table-header">
      <span class="txt">应用计划测量点列表</span>
      <el-button size="small" @click="addPlan">添加</el-button>
      <el-button type="primary" size="small" @click="savePlan">保存</el-button>
      <el-button type="danger" size="small" @click="closePlan">返回定额列表</el-button>
    </div>
    <div class="dejhglInfo-header">
      <div class="item">
        <span class="label">计划名称：</span>
        <div class="input">
          <el-input v-model.lazy="planName" placeholder="请输入能源计划名称" size="small"></el-input>
        </div>
      </div>
      <div class="item">
        <span class="label">计划时间：</span>
        <div class="input">
          <el-date-picker v-model="planTime" type="datetime" placeholder="选择开始时间" size="small" :editable="false"></el-date-picker>
        </div>
      </div>
      <div class="item">
        <span class="label">时间粒度：</span>
        <div class="input">
          <el-select v-model="timeGranularityValue" placeholder="请选择" size="small" style="width:70px">
            <el-option v-for="item in timeGranularity" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="dejhglInfo-table">
      <div class="dejhglInfo-table-main">
        <nk-table id="table" height="100%" :data="tableData" :noDataTitle="'暂无数据'" :columns="columns" :stripe="false">
          <el-table-column label="测量点" slot="measure" align="center">
            <template slot-scope="scope">
              <div style="color:#66b1ff;cursor:pointer;" @click="selectTree(scope)">{{scope.row.measure.label || '请选择测量点'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数据项" slot="measureData" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.dataValue" placeholder="请选择" size="small" :disabled="scope.row.measure.label?false:true" @change="dataChange($event,scope.row)">
                <el-option-group v-for="group in scope.row.dataOptions" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.id" :label="item.displayName" :value="item.id"></el-option>
                </el-option-group>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="预期值" slot="desiredValue" align="center">
            <template slot-scope="scope">
              <el-input-number class="inputNumber" v-model="scope.row.desiredValue" label="请输入预期值" :disabled="scope.row.dataValue!=''?false:true" size="small"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="比较范围" slot="compare" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.compare" placeholder="请选择" size="small">
                <el-option v-for="item in compare" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="removeTableItem(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
    </div>
    <el-dialog title="请选择树节点(单选)" :visible.sync="selectNodeDialog" custom-class="dialog">
      <div class="dialog-info">
        <div class="view-tree">
          <div :class="['view-tree-item',index === viewTreeIndex ? 'view-tree-select':'']" v-for="(item,index) in viewTree" :key="index" @click="viewTreeClick(item,index)">{{item.displayName}}</div>
        </div>
        <div class="dialog-box" style="width:100%;height:300px;">
          <nk-left-tree ref="tree" :defaultCurrent="false" :data="leftTreeData" v-if="leftTreeData.length > 0" @click="nodeClick"></nk-left-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectNodeDialog = false">取 消</el-button>
        <el-button type="primary" @click="selectNodeEnter">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NkLeftTree from "@/components/common/NkLeftTree"
import NkTable from "@/components/common/NkTable";
import * as utils from "@/utils/index.js";
import DateTool from "@/utils/dateTool.js";
export default {
  name: "dejhglInfo",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    planName: {//计划名称
      type: String,
      default: ""
    },
    planTime: {//计划时间
      type: String
    },
    timeGranularityValue: {//默认的时间粒度
      type: String,
      default: "1"
    },
    showPlanInfo: {//是否显示计划列表
      type: Boolean,
      default: true
    },
    planId: {//计划ID
      type: String,
      default: ""
    }
  },
  components: {
    NkTable, NkLeftTree
  },
  data () {
    return {
      timeGranularity: [//时间粒度
        { label: "月", value: "1" },
        { label: "年", value: "2" }
      ],
      tableData: [],//表格数据
      columns: [{
        prop: "measure",
        label: "测量点",
        slot: "measure"
      }, {
        prop: "measureData",
        label: "数据项",
        slot: "measureData"
      }, {
        prop: "desiredValue",
        label: "预期值",
        slot: "desiredValue"
      }, {
        prop: "compare",
        label: "比较范围",
        slot: "compare"
      }],//表格列
      compare: [{//比较范围
        label: "大于",
        value: "1"
      }, {
        label: "小于",
        value: "2"
      }],
      selectNodeDialog: false,//视图弹窗
      viewTree: [],//视图树数据
      leftTreeData: {},//指定视图树的具体树数据
      viewTreeIndex: -1,//当前选中的视图数据
      isViewTreeData: true,//是否可以进行请求下次的视图树数据
      editTableIndex: -1,//当前编辑的是第几行，从0开始
      thisNode: {},//当前节点
    }
  },
  async mounted () {
    await this.getTreeData();//请求树数据
    if (this.planId != "") {//存在计划ID
      this.getEnergyPlanDesires();
    }
  },
  methods: {
    async getTreeData () {
      let result = await this.$api.view.getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId);
      if (result.success) {
        this.viewTree = result.data;
      }
    },
    async getEnergyPlanDesires () {//查询计划id详情
      let result = await this.$api.energyPlan.getEnergyPlanDesires(this.planId);
      if (!result.success) {
        this.$message.error(result.errorStr);
        return;
      }
      for (let i = 0; i < result.data.length; i++) {//处理增加数据项等数据信息
        let expressionGroups = await this.getMeasuresExpressions(result.data[i].measureId, i, true);
        result.data[i].dataOptions = [];
        expressionGroups.forEach(item => {
          result.data[i].dataOptions.push({//设置数据项
            label: item.displayName,
            options: item.expression
          });
          for (let m = 0; m < item.expression.length; m++) {//设置数据项的选中
            if (item.expression[m].name == result.data[i].expressionName) {
              result.data[i].dataValue = item.expression[m].id;
              break;
            }
          }
        });
        result.data[i].measure = {//设置测量点信息
          id: result.data[i].measureId,
          label: result.data[i].measureName
        }
        result.data[i].compare = result.data[i].compare + "";//设置比较范围
      }
      this.tableData = Object.assign([], result.data);//渲染当前计划id下的数据到表格中
    },
    selectTree (row) {//选择树节点
      this.editTableIndex = row.$index;//当前编辑的是第几行，从0开始
      this.selectNodeDialog = true;
    },
    async viewTreeClick (item, index) {//点击视图时
      if (!this.isViewTreeData) {
        return;
      }
      this.viewTreeIndex = index;
      this.isViewTreeData = false;//避免不断点击，造成疯狂请求
      let result = await this.$api.view.getViewTreeNodes(item.id);
      this.isViewTreeData = true;
      if (!result.success) {
        this.$message.error(result.errorStr);
        return;
      }
      this.leftTreeData = utils.creatTreeData(result.data, 0);
    },
    nodeClick (data) {//节点点击
      this.thisNode = data;
    },
    selectNodeEnter () {//视图树弹窗点击确定
      if (!this.thisNode) {//如果没有选择节点，则
        this.$message.error('请选择节点名称!');
        return;
      }
      this.tableData[this.editTableIndex].measure = Object.assign({}, this.thisNode);//选择节点后，设置当前行数据
      this.getMeasuresExpressions(this.thisNode.id, this.editTableIndex);//然后请求当前节点ID的数据项，当前行
      this.tableData[this.editTableIndex].dataValue = "";//当前行的数据项清零
      this.selectNodeDialog = false;//关闭弹窗
    },
    addPlan () {//点击添加计划按钮
      this.tableData.push({
        measure: {},
        measureData: [],
        desiredValue: "",
        compare: "1",//比较范围
        dataValue: "",
        pointCode: "",
        pointNumber: "",
        dataOptions: [],//数据项
      });
    },
    removeTableItem (index) {//删除某一行的计划
      this.$confirm('是否删除当前计划', '计划删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {//确认删除
        if (this.tableData[index].id) {//如果存在id，要调接口删除
          let deleteResult = await this.$api.energyPlan.deleteEnergyPlanDesire(this.tableData[index].id);
          if (!deleteResult.success) {
            this.$message.error(deleteResult.errorStr);
            return;
          }
          this.$message.success(deleteResult.errorStr);
        }
        this.tableData.splice(index, 1);
      });
    },
    closePlan () {//关闭计划列表
      this.$emit("update:showPlanInfo", false);
    },
    dataChange (val, row) {//数据项改变时触发，设置pointCode与num
      for (let i = 0; i < row.dataOptions.length; i++) {
        let temp = row.dataOptions[i].options;
        let itemData = temp.find(item => item.id == val);
        if (itemData) {
          row.pointCode = itemData.pointCode;
          row.pointNumber = itemData.pointNumber;
          break;
        }
      }
    },
    async getMeasuresExpressions (nodeId, index, flag) {//然后请求当前节点ID的数据项
      let result = await this.$api.measure.getUniqueMeasuresExpressions(JSON.stringify([nodeId]));
      if (!result.success) {
        this.$message.error('请选择节点名称!');
        return;
      }
      let expressionGroups = result.data[0].expressionGroups;
      if (flag) {
        return expressionGroups;
      }
      this.tableData[index].dataOptions = [];
      expressionGroups.forEach(item => {
        this.tableData[index].dataOptions.push({
          label: item.displayName,
          options: item.expression
        });
      });
    },
    async savePlan () {//点击保存
      //先判断参数符不符合要求
      if (!(this.planName != "" && this.planTime != "")) {//计划名称与时间不能为空
        this.$message.error('计划名称与时间都不能为空!');
        return;
      }
      //再判断表格的输入项是否满足
      let flag = true;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].desiredValue === "") {//如果存在预期值为空的情况
          flag = false;
          break;
        }
      }
      if (!flag) {//表格存在没缺失数据项
        this.$message.error('请完善表格的数据项');
        return;
      }
      let planId = this.planId;
      if (planId == "") {//计划ID为空时,才需要创建计划
        const planResult = await this.createEnergyPlan();
        if (!planResult.success) {
          //this.$message.error(planResult.msg);
          return;
        }
        this.planId = planResult.data.id;//当前新建的计划ID
        this.$message.success(planResult.errorStr);
        planId = planResult.data.id;//保留新建的计划ID
      } else {//编辑计划
        const editPlanResult = await this.modifyEnergyPlan();
        if (!editPlanResult.success) {
          //this.$message.error(editPlanResult.msg);
          return;
        }
        this.$message.success(editPlanResult.errorStr);
      }
      //创建计量点计划
      await this.addEnergyPlanDesire(planId); //传递计划ID 
    },
    async createEnergyPlan () {//创建计划
      let planResult = await this.$api.energyPlan.createEnergyPlan(0, this.planName, DateTool.format(new Date(this.planTime), "yyyy-MM-dd hh:mm:ss"), this.timeGranularityValue);
      return planResult;
    },
    async modifyEnergyPlan () {//编辑计划
      let editPlanResult = await this.$api.energyPlan.modifyEnergyPlan(this.planId, this.planName, DateTool.format(new Date(this.planTime), "yyyy-MM-dd hh:mm:ss"), this.timeGranularityValue);
      return editPlanResult;
    },
    async addEnergyPlanDesire (planId) {//创建计量点计划
      let desires = [];
      this.tableData.map((item, key) => {
        desires.push({
          temporaryId: key + '',
          measureId: item.measure.id,
          pointCode: item.pointCode,
          pointNumber: item.pointNumber,
          desiredValue: item.desiredValue,
          compare: item.compare
        });
      });
      if (desires.length == 0) {
        return;
      }
      let desireResult = await this.$api.energyPlan.setEnergyPlanDesires(planId, JSON.stringify(desires));
      if (!desireResult.success) {
        //this.$message.error(desireResult.msg);
        return;
      }
      this.$message.success(desireResult.errorStr);
    }
  }
}
</script>

<style lang="scss" scoped>
.dejhglInfo-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  .dejhglInfo-table-header {
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d8d8d8;
    .txt {
      color: #333;
      margin-right: 10px;
    }
  }
  .dejhglInfo-header {
    display: flex;
    align-items: center;
    padding: 5px 0;
    border-bottom: 1px solid #d8d8d8;
    .item {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .label {
        color: #333;
      }
    }
  }
  .dejhglInfo-table {
    flex: 1;
    width: 100%;
    position: relative;
    .inputNumber {
      width: auto;
    }
    .dejhglInfo-table-main {
      position: absolute;
      top: 0px;
      bottom: 0;
      width: 100%;
      overflow: hidden;
      padding: 5px;
      box-sizing: border-box;
      ::v-deep .el-table--border {
        border-bottom: 1px solid #ebeef5;
      }
      ::v-deep .table-warp .el-table td {
        border-bottom: 1px solid #ebeef5;
      }
    }
  }
  .dialog-info {
    display: flex;
    width: 100%;
    height: 300px;
    border: 1px solid #d5dadd;
    .view-tree {
      width: 200px;
      height: 300px;
      border-right: 1px solid #d5dadd;
      overflow-y: auto;
      .view-tree-item {
        line-height: 28px;
        padding: 0 5px;
        box-sizing: border-box;
        border-bottom: 1px dashed #d5dadd;
        cursor: pointer;
        font-size: 14px;
      }
      .view-tree-select {
        background: #d5dadd;
      }
    }
    .dialog-box {
      flex: 1;
      overflow-y: auto;
      padding: 0 5px;
      box-sizing: border-box;
      .tree-warp {
        height: 100%;
      }
    }
  }
}
</style>